// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueIntercom from 'vue-intercom';
import VueCookies from 'vue-cookies';
import { initHCProps } from 'lion-vue';
import FullCalendar from 'vue-full-calendar'

import 'vue-swatches/dist/vue-swatches.css'

import '../node_modules/vuetify/src/stylus/app.styl';
import './Core/plugins/vuetify';
import './Core/assets/scss/main.scss';
import App from './App';
import { feathers } from './feathers-client';
import Router from './router';
import Store from './store';
import AppLayout from './Core/layouts/AppLayout';

initHCProps({
  MAIN_DOMAIN: process.env.VUE_APP_MAIN_DOMAIN,
  MLS_API: process.env.VUE_APP_MLS_API,
  MLS_APP_URL: process.env.VUE_APP_MLS_URL,
  ACCOUNTS_API: process.env.VUE_APP_ACCOUNTS_API,
  ACCOUNTS_APP_URL: process.env.VUE_APP_ACCOUNTS_APP_URL,
  TRANSACTIONS_APP_URL: process.env.VUE_APP_TX_URL,
  PLATFORM_APP_URL: process.env.VUE_APP_CRM_URL,
  NYLAS_API_BASE_URL: process.env.VUE_APP_NYLAS_API_BASE_URL,
  COMMUNICATIONS_API_BASE_URL: process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL,
  UL_PLATFORM_URL: process.env.VUE_APP_UL_PLATFORM_URL,
  LW_DOMAIN: process.env.VUE_APP_LW_DOMAIN,
  AUTHENTICATION_API_BASE_URL: process.env.VUE_APP_AUTHENTICATION_API_BASE_URL,
  NEWGEN_API_BASE_URL: process.env.VUE_APP_NEWGEN_API_BASE_URL,
  RELATIONSHIPS_URL: process.env.VUE_APP_RELATIONSHIPS_URL,
});

Vue.component('AppLayout', AppLayout);

Vue.use(feathers);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.component(FullCalendar)

Vue.use(VueIntercom, { appId: process.env.VUE_APP_INTERCOM_APP_ID });

const app = new Vue({
  router: Router,
  store: Store,
  components: { App },
  render: h => h(App),
}).$mount('#app');

if (window.Cypress) {
  window.app = app;
}
